import React, { Component } from 'react';
//components

//styles
import './scss/header.scss';
import MobileMenu from './MobileMenu';
import DecadesYears from '../DecadesYears/DecadesYears';
import decadesJSON from "../../api/decades.json"

class Header extends Component {
  state = {
    transform: -100,
    shareUrl: "https://z.ynet.co.il/mshort/content/2018/GolshimBaZman/#",
    showSelectTransform: false,
    isDecadeMenuVisible: false,
    decadeIdTransform: 45
  }
  negishut() {
    document.getElementById('INDmenu-btn').click();
  }
  shareFacebook = () => {
    window.open("https://www.facebook.com/share.php?u=" + this.state.shareUrl, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Facebook", this.state.shareUrl);
  }
  shareTwitter = () => {
    let title = "גולשים בזמן - ynet";
    let description = "מערכות קשות והפגנות סוערות, חגיגות לאומיות, צחוק ודמעות. לרגל 70 שנות עצמאות צאו למסע בזמן וקראו על האירועים הגדולים שעיצבו את פני מדינת ישראל."
    let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + this.state.shareUrl;
    window.open(url, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Twitter", this.state.shareUrl);
  }

  showMenu = (hideBirthday) => {
    this.setState({
      transform: 0
    });
    if (typeof hideBirthday !== 'undefined')
      hideBirthday(true);
  }
  closeMenu = (hideBirthday) => {
    this.setState({
      transform: -100
    });
    if (typeof hideBirthday !== 'undefined')
      hideBirthday(false);
  }
  setSelectTransform = () => {
    this.setState(prevState => ({
      showSelectTransform: !prevState.showSelectTransform,
      decadeIdTransform: !prevState.showSelectTransform ? 225 : 45
    }))
  }
  closeDecadesMenu = () => {
    if (this.state.showSelectTransform)
      this.setSelectTransform();
  }
  render() {
    return (
      <div>
        <div className={this.props.isDecade && !this.props.isDecadeMenuVisible ? "menu-button_mobile" : ""} onClick={() => this.showMenu(this.props.hideBirthday)}></div>
        <div className={this.props.isDecade && !this.props.isDecadeMenuVisible ? "share-container fixed menu-only" : this.props.isDecade ? "share-container fixed" : "share-container"} style={{ backgroundColor: this.props.bgColor, height: this.props.height, opacity: this.props.opacity }}>
          <MobileMenu
            negishut={this.negishut}
            shareFacebook={this.shareFacebook}
            shareTwitter={this.shareTwitter}
            closeMenu={() => this.closeMenu(this.props.hideBirthday)}
            transform={this.state.transform}
            decadesJSON={decadesJSON}
            currentDecade={this.props.isDecade ? decadesJSON[this.props.decadeId - 1].id : null}
            sendGA={this.props.sendGA}
          />
          <div className="menu" tabIndex="0" onBlur={() => this.closeDecadesMenu()}>
            {this.props.isDecade ? <a href="./#/" onClick={() => this.props.vPush("גולשים בזמן", "#/")}><div className="main-img-header"></div></a> : ""}
            {this.props.isDecade ? <div className="decade-id" id="decade-id" onClick={this.setSelectTransform}>{decadesJSON[this.props.decadeId - 1].title}<div className="arrow" style={{ transform: "rotate(" + this.state.decadeIdTransform + "deg)", top: (this.state.showSelectTransform ? "5px" : "0px") }}></div></div> : ""}

            {this.props.isDecade
              ?
              <DecadesYears
                decadesJSON={decadesJSON}
                showSelectTransform={this.state.showSelectTransform}
                currentDecade={decadesJSON[this.props.decadeId - 1].id}
                setSelectTransform={this.setSelectTransform}
                sendGA={this.props.sendGA}
              />
              : ""}

            <div className={this.props.isDecade ? "menu-icon-inner" : "menu-icon"} onClick={() => this.showMenu(this.props.hideBirthday)}></div>
            <ul className="menu-list" id="menu" >
              <a href="https://redmail.ynet.co.il" target="_blank">
                <li className="write-us">כתבו לנו</li>
              </a>
              <li className="twitter" onClick={this.shareTwitter}></li>
              <li className="facebook" onClick={this.shareFacebook}></li>
              <li className="accessibility" onClick={this.negishut}></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js